export default (id = null) => ({
  id,
  type: 'content',
  text: '\n',
  properties: '\n',
  hash: 0,
});
